import { Icon } from "@iconify/react/dist/iconify.js";

const Page202Confrimshare = () => {
  return (
    <div className="content-404">
      <div className="showdetail-404">
        <div className="boxdetail-show">
          <div>
            <Icon icon="pajamas:time-out" height={"40%"} width={"40%"} />
          </div>
          <div>
            <span>หมดเวลาตอบรับ หรือ การตอบรับเสร็จสิ้น !!!</span>
          </div>
        </div>
        <div></div>
      </div>
    </div>
  );
};
export default Page202Confrimshare;
